<template>
  <transition name="fade">
    <div v-if="show" class="update-popup">
      <div class="update-popup-content">
        <h3>{{ title }}</h3>
        New update coming up <strong>{{ days }} days {{ hours }} hours {{ minutes }} minutes {{ seconds }} seconds</strong>
        <p class="text-secondary">{{ message }}</p>
        <img src="@/assets/img/newupdate.jpeg" class="img" >
        <div class="update-popup-actions">
          <button @click="refresh" class="refresh-button">
            {{ refreshButtonText }}
          </button>
          <button v-if="showLater" @click="dismiss" class="later-button">
            {{ laterButtonText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UpdatePopup',
  props: {
    title: {
      type: String,
      default: 'New Update Available'
    },
    message: {
      type: String,
      default: 'A new version of the application is available. Please refresh to update.'
    },
    refreshButtonText: {
      type: String,
      default: 'Refresh Now'
    },
    laterButtonText: {
      type: String,
      default: 'Later'
    },
    showLater: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      timeLeft: 0, // Total time left in milliseconds
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null,
    }
  },
  methods: {
    updateCountdown() {
      // Get current date
      const now = new Date();

      // Get next Sunday (the next 00:00:00 on Sunday)
      const nextSunday = new Date(now);
      nextSunday.setDate(now.getDate() + (16 - now.getDay())); // Set to next Sunday
      nextSunday.setHours(0, 0, 0, 0); // Set time to midnight

      // Calculate the time difference
      this.timeLeft = nextSunday - now;

      // If timeLeft is less than or equal to 0, stop the countdown
      if (this.timeLeft <= 0) {
        clearInterval(this.timer); // Stop the countdown
        return;
      }

      // Calculate days, hours, minutes, and seconds
      this.days = Math.floor(this.timeLeft / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((this.timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.timeLeft % (1000 * 60)) / 1000);
    },

    startCountdown() {
      this.updateCountdown();

      this.timer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    showPopup() {
      this.show = true
    },
    hidePopup() {
      this.show = false
    },
    refresh() {
      const url = `https://youtu.be/mDrXz5XweNY`
      window.open(url, '_blank');
      this.hidePopup();
    },
    dismiss() {
      this.hidePopup()
      this.$emit('dismissed')
    }
  },
  created() {
    this.startCountdown();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>

<style scoped>
.img{
  height: 150px;
  width: 250px;
  object-fit: contain;
}
.update-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.update-popup-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  text-align: center;
}

.update-popup-actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

button {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.refresh-button {
  background-color: #4CAF50;
  color: white;
}

.later-button {
  background-color: #f5f5f5;
  color: #666;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>